/*
 * @Author: your name
 * @Date: 2021-07-01 10:00:06
 * @LastEditTime: 2021-07-22 11:19:04
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /WuKong-mobile-web/src/pages/browser/router/index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)
// 解决上面跳转加参数报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

// 修改路由replace方法,阻止重复点击报错
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const routes = [
  {
    path: '/invatationCode',
    name: 'InvatationCode',
    component: () => import(/* webpackChunkName: "browser-invatationCode" */'../views/InvatationCode/Index.vue'),
    meta: { title: '好友邀请你加入翎氪' }
  },
  {
    path: '/invatationExpire',
    name: 'invatationExpire',
    component: () => import(/* webpackChunkName: "browser-invatationExpire" */'../views/invatationExpire/Index.vue'),
    meta: { title: '好友邀请你加入翎氪' }
  },
  {
    path: '/invatationInfo',
    name: 'InvatationInfo',
    component: () => import(/* webpackChunkName: "browser-invatationInfo" */'../views/InvatationInfo/Index.vue'),
    meta: { title: '翎氪申请资料' }
  },
  {
    path: '/successInvatation',
    name: 'SuccessInvatation',
    component: () => import(/* webpackChunkName: "browser-successInvatation" */ '../views/InvatationCode/SuccessInvatation.vue'),
    meta: { title: '好友邀请你加入翎氪' }
  },
  {
    path: '/feed',
    name: 'Feed',
    component: () => import(/* webpackChunkName: "browser-feed" */'../views/Feed/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/articleShare',
    name: 'articleShare',
    component: () => import(/* webpackChunkName: "browser-articleShare" */'../views/articleShare/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/backflow',
    name: 'Backflow',
    component: () => import(/* webpackChunkName: "browser-backflow" */'../views/backflow/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/downloadApp',
    name: 'DownloadApp',
    component: () => import(/* webpackChunkName: "browser-downloadApp" */'../views/downloadApp/Index.vue'),
    meta: { title: '下载页' }
  },
  {
    path: '/bindPhoneNumber',
    name: 'BindPhoneNumber',
    component: () => import(/* webpackChunkName: "browser-bindPhoneNumber" */'../views/bindPhoneNumber/Index.vue'),
    meta: { title: '绑定手机号' }
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: () => import(/* webpackChunkName: "browser-favorites" */'../views/favorites/Index.vue'),
    meta: { title: '我的全网收藏夹' }
  },
  {
    path: '/notInvited',
    name: 'NotInvited',
    component: () => import(/* webpackChunkName: "browser-notInvited" */'../views/notInvited/Index.vue'),
    meta: { title: '江湖救急：请好友们赐我翎氪邀请码' }
  },
  {
    path: '/bindingProcess',
    name: 'BindingProcess',
    component: () => import(/* webpackChunkName: "browser-bindingProcess" */'../views/bindingProcess/Index.vue'),
    meta: { title: '微信服务号流程' }
  },
  {
    path: '/kryptonDetail',
    name: 'KryptonDetail',
    component: () => import(/* webpackChunkName: "browser-kryptonDetail" */'../views/kryptonDetail/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/H5buymidle',
    name: 'H5buymidle',
    component: () => import(/* webpackChunkName: "browser-H5buymidle" */'../views/H5buymidle/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/phonelogin',
    name: 'phonelogin',
    component: () => import(/* webpackChunkName: "browser-phonelogin" */'../views/phonelogin/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import(/* webpackChunkName: "browser-welcome" */'../views/welcome/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/invatation',
    name: 'invatation',
    component: () => import(/* webpackChunkName: "browser-invatation" */'../views/invatation/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import(/* webpackChunkName: "browser-invite" */'../views/invite/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/talkroom',
    name: 'talkroom',
    component: () => import(/* webpackChunkName: "browser-talkroom" */'../views/talkroom/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/talkroomInvite',
    name: 'talkroomInvite',
    component: () => import(/* webpackChunkName: "browser-talkroomInvite" */'../views/talkroomInvite/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/answer',
    name: 'answer',
    component: () => import(/* webpackChunkName: "browser-answer" */'../views/answer/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/RQResult',
    name: 'RQResult',
    component: () => import(/* webpackChunkName: "browser-RQResult" */'../views/RQResult/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/medalshare',
    name: 'medalshare',
    component: () => import(/* webpackChunkName: "browser-medal" */'../views/medal/Share.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/weixinLoginMid',
    name: 'weixinLoginMid',
    component: () => import(/* webpackChunkName: "browser-weixinLoginMid" */'../views/weixinLoginMid/Index.vue'),
    meta: { title: '翎氪' }
  },
  {
    path: '/NFTActive',
    name: 'NFTActive',
    component: () => import(/* webpackChunkName: "browser-NFTActive" */'../views/NFTActive/index.vue'),
    meta: { title: '翎氪' },
    children:[
      {
        path: 'homePage',
        name: 'homePage',
        component: () => import(/* webpackChunkName: "browser-homePage"*/'../views/NFTActive/pages/homePage/index.vue'),
      },
      {
        path: 'indexPage',
        name: 'indexPage',
        component: () => import(/* webpackChunkName: "browser-indexPage"*/'../views/NFTActive/pages/indexPage/index.vue'),
      },
      {
        path:'weixinloginmiddle',
        name:'weixinloginmiddle',
        component: () => import(/* webpackChunkName: "browser-weixinloginmiddle" */'../views/NFTActive/pages/weixinloginmiddle/index.vue'),
      },
      {
        path: 'chooseLook',
        name: 'chooseLook',
        component: () => import(/* webpackChunkName: "browser-chooseLook" */'../views/NFTActive/pages/chooseLook/Index.vue'),
      },
      {
        path: 'nftposter',
        name: 'nftposter',
        component: () => import(/* webpackChunkName: "browser-nftposter" */'../views/NFTActive/pages/nftposter/Index.vue'),
      },
      {
        path: 'nftagree',
        name: 'nftagree',
        component: () => import(/* webpackChunkName: "browser-nftagree" */'../views/NFTActive/pages/nftagree/Index.vue'),
      },
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "browser-login" */'../views/NFTActive/pages/login/Index.vue'),
      },
      {
        path: 'previewCar',
        name: 'previewCar',
        component: () => import(/* webpackChunkName: "browser-previewCar" */'../views/NFTActive/pages/previewCar/Index.vue'),
      },
      {
        path: 'mycollect',
        name: 'mycollect',
        component: () => import(/* webpackChunkName: "browser-mycollect" */'../views/NFTActive/pages/mycollect/Index.vue'),
      },
      {
        path: 'collectdetail',
        name: 'collectdetail',
        component: () => import(/* webpackChunkName: "browser-collectdetail" */'../views/NFTActive/pages/collectdetail/Index.vue'),
      },
      {
        path: 'nftinvite',
        name: 'nftinvite',
        component: () => import(/* webpackChunkName: "browser-nftinvite" */'../views/NFTActive/pages/nftinvite/Index.vue'),
      },
      {
        path: 'nftdownload',
        name: 'nftdownload',
        component: () => import(/* webpackChunkName: "browser-nftdownload" */'../views/NFTActive/pages/nftdownload/Index.vue'),
      },
      {
        path: 'mycollectdetail',
        name: 'mycollectdetail',
        component: () => import(/* webpackChunkName: "browser-mycollectdetail" */'../views/NFTActive/pages/mycollectdetail/Index.vue'),
      },
      {
        path:'customizedCar',
        name:'customizedCar',
        component: () => import(/* webpackChunkName: "browser-customizedCar" */'../views/NFTActive/pages/customizedCar/customizedCar.vue'),
      },
      {
        path:'customizedCar-body',
        name:'customizedCar-body',
        component: () => import(/* webpackChunkName: "browser-customizedCar-body" */'../views/NFTActive/pages/customizedCar-body/customizedCar.vue'),
      },
      {
        path:'customizedCar-other',
        name:'customizedCar-other',
        redirect:{name:"颜色"},
        component: () => import(/* webpackChunkName: "browser-customizedCar-other" */'../views/NFTActive/pages/customizedCar-other/index.vue'), 
        children:[

          {
            meta:{
              name:'车轮',
            },
            name:'车轮',
            path:'setwheel',
            component: () => import(/* webpackChunkName: "browser-customizedCar-other-setwheel" */'../views/NFTActive/pages/customizedCar-other/pages/setwheel/index.vue')
          },
          {
            meta:{
              name:'车灯',
            },
            path:'setLight',
            name:'车灯',
            component: () => import(/* webpackChunkName: "browser-customizedCar-other-setLight" */'../views/NFTActive/pages/customizedCar-other/pages/setLight/index.vue'),
           
          },
          {
            meta:{
              name:'颜色',
            },
            path:'setColor',
            name:'颜色',
            component: () => import(/* webpackChunkName: "browser-customizedCar-other-setColor" */'../views/NFTActive/pages/customizedCar-other/pages/setColor/index.vue')
          },
          {
            meta:{
              name:'装饰',
            },
            path:'setDecorate',
            name:'装饰',
            component: () => import(/* webpackChunkName: "browser-customizedCar-other-setDecorate" */'../views/NFTActive/pages/customizedCar-other/pages/setDecorate/index.vue')
          },
        ]
      },
      {
        path:'customizedZoom',
        name:'customizedZoom',
        component: () => import(/* webpackChunkName: "browser-customizedZoom" */'../views/NFTActive/pages/customizedZoom/index.vue'),
      },

      {
        path:'CollectionList',
        name:'CollectionList',
        component: () => import(/* webpackChunkName: "browser-CollectionList" */'../views/NFTActive/pages/CollectionList/index.vue'),
      },
    ]
  },
  {
    path:'/annisersary',
    name:'annisersary',
    component: () => import(/* webpackChunkName: "browser-annisersary" */'../views/annisersary/index.vue'),
    children: [
      {
        path:'loadpage',
        name:'loadpage',
        component: () => import(/* webpackChunkName: "browser-loadpage" */'../views/annisersary/pages/loadpage/index.vue'),
      },
      {
        path:'question',
        name:'question',
        meta: {
          title: '测一测你的阅读DNA'
        },
        component: () => import(/* webpackChunkName: "browser-question" */'../views/annisersary/pages/question/index.vue'),
      },
      {
        path:'rules',
        name:'rules',
        component: () => import(/* webpackChunkName: "browser-annisersary-rules" */'../views/annisersary/pages/rules/index.vue'),
      },
      {
        path:'questionResult',
        name:'questionResult',
        component: () => import(/* webpackChunkName: "browser-questionResult" */'../views/annisersary/pages/questionResult/index.vue'),
      },
      {
        path:'linkr',
        name:'linkr',
        component: () => import(/* webpackChunkName: "browser-linkr" */'../views/annisersary/pages/linkr/index.vue'),
      },
      {
        path:'loginPhone',
        name:'loginPhone',
        component: () => import(/* webpackChunkName: "browser-loginPhone" */'../views/annisersary/pages/loginPhone/index.vue'),
      },
      {
        path:'myPrize',
        name:'myPrize',
        component: () => import(/* webpackChunkName: "browser-myPrize" */'../views/annisersary/pages/myPrize/index.vue'),
      },
    ]
  },
  {
    path:'/linkr-view',
    name:'linkr-view',
    component: () => import(/* webpackChunkName: "browser-linkr-view" */'../views/linkr-view/index.vue'),
  },
]
const router = new VueRouter({
  mode: 'history',
  base: '/page/browser',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '翎氪';
  if(from.query.from && !to.query.from){
    next({
      ...to,
      query: {
        ...to.query,
        from: from.query.from
      }
    });
  } else {
    next();
  }
  
})

export default router
